const config = {
    host: "https://btb-fieldapp.exploserv.com/api",
    production: "true",
    
};

export default config;
